module.exports = __webpack_public_path__ + "static/media/logo_esa.5643a7e8.png";